module.exports = __webpack_public_path__ + "static/img/4ft.559e7cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/consult/image/4ft.png
// module id = eaEM
// module chunks = 6